<template>
    <div>
        <BjImportFile
            ref="BjImportFile"
            accept=".xls,.xlsx"
            :limit-size="128 * 1024"
            auto-upload
            @importFile="importFile"
        >
        </BjImportFile>
        <div class="flex-align-justify">
            <BjInput v-model="time" placeholder="执行秒数" style="width:300px;margin: 20px 0" />
        </div>
        <div class="flex-align-justify">
            <el-button type="primary" @click="confirm">生成订单发货通知单,并解除库存锁定</el-button>
            <el-button type="primary" @click="confirm2">手动发货并解除库存锁定</el-button>
        </div>
    </div>
</template>

<script>
import axios from '@/utils/axios';

export default {
    data() {
        return {
            tableData: [],
            time: 5
        };
    },
    methods: {
        importFile(file) {
            this.tableData = [];
            // const _this = this;
            const reader = new FileReader();
            reader.readAsArrayBuffer(file);
            reader.onload = () => {
                const buffer = reader.result;
                const bytes = new Uint8Array(buffer);
                const length = bytes.byteLength;
                let binary = '';
                for (let i = 0; i < length; i++) {
                    binary += String.fromCharCode(bytes[i]);
                }
                const XLSX = require('xlsx');
                const wb = XLSX.read(binary, { type: 'binary' });
                const outData = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);
                this.tableData = outData;
                console.log(this.tableData);
            };
        },
        beforeApi(item, val = 1) {
            if (val == 1) {
                axios({
                    method: 'post',
                    url: `/sord/v1/order/order-delivery`,
                    data: {
                        orderCode: item['order_code']
                    },
                }).then(() => {
                });
            } else {
                axios({
                    method: 'post',
                    url: `/stock/v1/result-records/send-stock-by-hand`,
                    data: {
                        orderNo: item['order_code']
                    },
                }).then(() => {
                });
            }
        },
        confirm() {
            if (this.tableData.length == 0) return;
            const _this = this;
            this.tableData.forEach((item, index) => {
                (function (t, data) { // 注意这里是形参
                    setTimeout(function () {
                        _this.beforeApi(item, 1);
                        // console.log(`这是第 ${t} 次，这是其他参数：${data}`);
                    }, _this.time * 1000 * t);
                })(index, '');
            });
        },
        confirm2() {
            if (this.tableData.length == 0) return;
            const _this = this;
            this.tableData.forEach((item, index) => {
                (function (t, data) { // 注意这里是形参
                    setTimeout(function () {
                        _this.beforeApi(item, 2);
                        // console.log(`这是第 ${t} 次，这是其他参数：${data}`);
                    }, _this.time * 1000 * t);
                })(index, '');
            });
        }
    }
};
</script>
